<h1>{{ field.parent.parent.parent.props.label }}</h1> <!-- Tab title to which the form summary field belongs -->
<div *ngIf="field.parent.parent.parent.props.formSummaryDescription != null">
  {{ field.parent.parent.parent.props.formSummaryDescription }}
  <!-- Tab formSummaryDescription to which the form summary field belongs -->
</div>
<div class="summary-section mt-6" *ngFor="let tab of getFormConfig(); let tabIndex = index">
  <!-- Start of tab -->
  <hr>
  <dspx-heading *ngIf="props.showPageLink" [level]="2" [heading]="tab.props.label"></dspx-heading>
  <div *ngFor="let page of tab.fieldGroup; let pageIndex = index;">
    <!-- Start of page -->
    <ng-container *ngIf="showPageInSummary(page)">
      <!-- Page heading -->
      <div class="flex">
        <button *ngIf="props.showPageLink" type="button" pButton pRipple [attr.aria-expanded]="page.props.summaryHidden ? false : true" (click)="page.props.summaryHidden = !page.props.summaryHidden"
                class="my-0 p-button-text p-button-rounded p-button-plain" id="form-summary-{{tabIndex}}-{{pageIndex}}"
                [icon]="page.props.summaryHidden ? 'pi pi-chevron-right' : 'pi pi-chevron-down'">
          <span class="sr-only">{{tab.props.label}}</span>
        </button>
        <dspx-heading [level]="getPageHeadingLevel()" [heading]="page.props.label"></dspx-heading>
      </div>

      <!-- Non-repeating page -->
      <ng-container *ngIf="isPageType(page.type)">
        <div *ngIf="page.props.summaryHidden !== true">
          <div *ngIf="page.props.formSummaryDescription != null" class="summary-paragraph">
            {{ page.props.formSummaryDescription }}
          </div>
          <dspx-validation-summary *ngIf="page.props?.isEditable && props.showValidationSummary" [pageField]="page"></dspx-validation-summary>
          <div *ngFor="let section of getFieldGroup(page); let sectionIndex = index">
            <!-- Start of section -->
            <ng-container *ngIf="section.hide !== true">
              <!-- Section heading -->
              <ng-container *ngIf="section.type !== 'section-verification'">
                <div [ngClass]="{'section-has-error': hasSectionValidationError(section)}">
                  <dspx-heading [level]="3" [heading]="section.props.label"></dspx-heading>
                </div>
              </ng-container>

              <div *ngIf="section.props.formSummaryDescription != null" class="summary-paragraph">
                {{ section.props.formSummaryDescription }}
              </div>
              <div class="flex">
                <a role="button" tabindex=sectionIndex class="page-link" title="{{getSectionLinkLabel()}}"
                   (click)="goToSection(tab, page, section)">
                  <i [ngClass]="getSectionLinkIcon(page)"></i>
                  <span>{{getSectionLinkLabel()}}</span>
                </a>
              </div>
                <!-- Non-repeating section -->
              <dl *ngIf="isSectionType(section.type) || section.type === 'section-verification'" class="grid">
                <div *ngFor="let question of getFieldGroup(section);" [ngClass]="{
                          'display-none': question.props.hideOnSummary === true ||
                                          getFieldVisibility(question, tab.key, page.key, -1, section.key, -1) === false ||
                                          question.type === 'paragraph' ||
                                          question.type === 'information' ||
                                          question.type === 'summary' ||
                                          question.props.label == null,
                          'col-12 md:col-12 mb-6': question.type === 'checkbox',
                          'col-12 md:col-6 mb-3': question.type !== 'checkbox'
                        }">
                  <dt class="label mb-2">{{ question.props.label }}</dt>
                  <dd *ngIf="question.type !== 'file'" class="ml-0"><div innerHTML="{{ getResponse(question, tab.key, page.key, -1, section.key, -1) }}"></div></dd>
                  <dd *ngIf="question.type === 'file'" class="ml-0">
                  <a [href]="buildUrl(question, tab.key, page.key, -1, section.key, -1)" target="_blank">{{ getResponse(question, tab.key, page.key, -1, section.key, -1) }}</a></dd>
                  <div class="p-invalid">
                    {{ getValidationErrorText(question, tab.key, page.key, -1, section.key, -1) }}
                  </div>
                </div>
                <p-divider></p-divider>
              </dl>

              <!-- Repeating section-->
              <dl *ngIf="isPageType(page.type) && isRepeatingSectionType(section.type)">
                <ng-container *ngTemplateOutlet="repeatingSections; context {$implicit: getFieldGroup(section), tableData: getSectionInstanceArray(tab.key, page.key, -1, section.key), tab: tab, page: page, pageindex: -1, section: section}">
                </ng-container>
              </dl>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!-- End of non-repeating page -->
      <!-- Repeating page -->
      <ng-container *ngIf="isRepeatingPageType(page.type)">
        <div *ngIf="page.props.summaryHidden !== true">
          <div *ngFor="let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);">
            <div *ngIf="page.props.formSummaryDescription != null" class="summary-paragraph">
              {{ page.props.formSummaryDescription }}
            </div>
            <dspx-validation-summary *ngIf="page.props?.isEditable && props.showValidationSummary" [pageField]="page"></dspx-validation-summary>
            <div *ngFor="let section of getFieldGroup(page); let sectionIndex = index">
              <!-- Start of section -->
              <ng-container *ngIf="section.hide !== true">
                <!-- Section heading -->
                <ng-container *ngIf="section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, repeatingPageIndex, section.key, -1) !== false; else repeatingPageSectionHeading">
                  <dspx-heading [level]="3" [heading]="section.props.label"></dspx-heading>
                </ng-container>
                <ng-template #repeatingPageSectionHeading>
                  <dspx-heading [level]="3" [heading]="section.props.label"></dspx-heading>
                </ng-template>

                <div *ngIf="section.props.formSummaryDescription != null" class="summary-paragraph">
                  {{ section.props.formSummaryDescription }}
                </div>

                <!-- Non-repeating section -->
                <dl *ngIf="isSectionType(section.type) || section.type === 'section-verification'" class="grid">
                  <div class="col-12">
                    <ng-container *ngIf="getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1) != null">
                      <dspx-heading [level]="4"
                                    [heading]="getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1)"></dspx-heading>
                    </ng-container>
                    <div class="grid">
                      <div *ngFor="let question of getFieldGroup(section);"
                           [ngClass]="{'display-none': question.props.hideOnSummary === true
                                  || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, -1) === false
                                  || question.type === 'paragraph'
                                  || question.type === 'information'
                                  || question.type === 'summary'
                                  || question.props.label == null,
                                  'col-12 md:col-12 mb-6': question.type === 'checkbox',
                                  'col-12 md:col-6 mb-3': question.type !== 'checkbox'
                                }">
                        <div class="col pt-3 pb-3">
                          <dt class="label mb-2">{{ question.props.label }}</dt>
                          <dd class="ml-0"><div innerHTML="{{ getResponse(question, tab.key, page.key, repeatingPageIndex, section.key, -1) }}"></div></dd>
                          <div class="p-invalid">
                            {{ getValidationErrorText(question, tab.key, page.key, repeatingPageIndex, section.key, -1) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </dl>

                <!-- Repeating section-->
                <dl *ngIf="isRepeatingSectionType(section.type)" class="grid">
                  <div class="col-12">
                    <ng-container *ngTemplateOutlet="repeatingSections; context {$implicit: getFieldGroup(section), tableData: getSectionInstanceArray(tab.key, page.key, repeatingPageIndex, section.key), tab: tab, page: page, pageindex: repeatingPageIndex, section: section}">
                    </ng-container>
                  </div>
                </dl>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- End of repeating page -->

      <div *ngIf="props.showPageLink" class="mb-3">
        <button type="button" pButton pRipple class="p-button-primary p-button-text" tabindex="0" title="Hide answers"
                (click)="hidePage(page, tabIndex, pageIndex)" icon="pi pi-chevron-up" label="Hide answers"></button>
      </div>

    </ng-container>
    <!-- End of page -->
  </div>
  <!-- End of tab -->
</div>
<ng-template #sectionQuestions let-class="class" let-containerClass="containerClass" let-section="section" let-tabKey="tabKey" let-pageKey="pageKey" let-repeatingPageIndex="repeatingPageIndex" let-sectionKey="sectionKey" let-repeatingSectionIndex="repeatingSectionIndex">
  <div *ngFor="let question of getFieldGroup(section);"
       class="{{class}}"
       [ngClass]="{'display-none': question.props.hideOnSummary === true
                                  || getFieldVisibility(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) === false
                                  || question.type === 'paragraph'
                                  || question.type === 'information'
                                  || question.type === 'summary'
                                  || question.props.label == null}">
    <div class="{{containerClass}}">
      <dt class="label mb-2">
        {{ question.props.label }}
        <span *ngIf="question.props.required && question.props.hideRequiredMarker !== true" aria-hidden="true">*</span>
        <button *ngIf="isQuickEditEnabled(question)" type="button" pButton pRipple
                (click)="showQuickEdit(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex)"
                class="p-button-text p-button-rounded quick-edit-button" icon="fas fa-pen"></button>
      </dt>
      <dd class="ml-0">
        <dspx-show-hide-text text="{{ getResponse(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) }}"></dspx-show-hide-text>
      </dd>
      <div class="p-invalid">
        {{ getValidationErrorText(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) }}
      </div>
    </div>
  </div>
</ng-template>
<ng-template #repeatingSections let-questions let-tableData="tableData" let-tab="tab" let-page="page" let-pageindex="pageindex" let-section="section">
  <p-table [value]="tableData">
    <ng-template pTemplate="header">
      <tr>
        <ng-container *ngFor="let col of questions">
          <th [ngClass]="{'display-none': col.props.hideOnSummary === true
             || col.type === 'paragraph'
             || col.type === 'information'
             || col.type === 'summary'
             || col.props.label == null}">
            {{col.props?.label}}
          </th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record>
      <tr>
        <ng-container *ngFor="let col of questions">
          <td [ngClass]="{'display-none': col.props.hideOnSummary === true
              || col.type === 'paragraph'
              || col.type === 'information'
              || col.type === 'summary'
              || col.props.label == null}">
            <div *ngIf="col.type !== 'file'" innerHTML="{{ getResponse(col, tab.key, page.key, pageindex, section.key, record.index) }}"></div>
            <div *ngIf="col.type === 'file'">
              <a [href]="buildUrl(col, tab.key, page.key, pageindex, section.key, record.index)" target="_blank">
                {{ getResponse(col, tab.key, page.key, pageindex, section.key, record.index) }}
              </a>
            </div>
            <div class="p-invalid">
              {{ getValidationErrorText(col, tab.key, page.key, pageindex, section.key, record.index) }}
            </div>
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
<ng-template #uploadFilesDownloadLinks let-data let-question="question">
  <!--show download link-->
  <ng-container *ngIf="data">
    <ng-container *ngFor="let file of data">
      <div class="col-12">
        <div class="filename" (click)="downloadFile(file, question.key)" role="button" [id]="'button-' + file"
             [aria-label]="'Click here to download ' + file">
          {{ file.name }}
        </div>
        <div class="button-container">
          <button pButton type="button" class="p-button-primary p-button-text"
                  label="Download" title="Download" icon="fas fa-download" (click)="downloadFile(file, question.key)"></button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
<p-dialog *ngIf="showQuickEditPopup" [(visible)]="showQuickEditPopup"
          modal="true" styleClass="dialog"
          [baseZIndex]="10000"
          focusTrap="true"
          closeAriaLabel="Close">
  <ng-template pTemplate="header">
    <h2 class="p-dialog-title" tabindex="-1" autofocus>{{getQuickEditPopupLabel()}}</h2>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="dialog-form">
      <form [formGroup]="quickEditForm">
        <formly-form [form]="quickEditForm" [fields]="quickEditQuestions" [model]="quickEditModel"></formly-form>
      </form>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (click)="updateQuickEditField()" label="Ok" title="Ok" styleClass="p-button-conversion"></p-button>
    <p-button (click)="closeQuickEditPopup()" label="Cancel" title="Cancel" styleClass="p-button-secondary"></p-button>
  </ng-template>
</p-dialog>
